import React from 'react';
import { Card, Form, Radio, Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/free-regular-svg-icons';
import './styles.css';

library.add(far);

const RadioGroupCardSociogram = ({
  questionText,
  classMate,
  name,
  required,
  options,
  hasIcon,
  onChange,
  question,
}) => {
  return (
    <Card
      title={
        <div>
          {questionText} {classMate ? <b>{classMate.name}</b> : null}
        </div>
      }
      className="radioGroupCard_card"
    >
      <Form.Item
        name={name}
        rules={[{ required: { required }, message: '*Respuesta obligatoria' }]}
      >
        <Radio.Group
          onChange={(e) => {
            onChange(name, question, e.target.value, [classMate]);
          }}
        >
          <Space
            direction="vertical"
            type="flex"
            align="middle"
            justify="center"
          >
            {options && options.length
              ? options.map((option) => {
                  return !hasIcon ? (
                    <Radio key={`radio-item-${option?.id}`} value={option.id}>
                      {option?.name}
                    </Radio>
                  ) : (
                    <Radio
                      key={`radio-item-${option?.id}`}
                      value={option.id}
                      className="radio_icon"
                    >
                      <div type="flex" align="middle" justify="center">
                        <FontAwesomeIcon
                          className="radioGroupCard_icon"
                          icon={['far', option?.icon]}
                        />{' '}
                        <span>{option?.name}</span>
                      </div>
                    </Radio>
                  );
                })
              : null}
          </Space>
        </Radio.Group>
      </Form.Item>
    </Card>
  );
};

export default RadioGroupCardSociogram;
